import { lazyAddinCommandSurfaceItemsObserver } from 'owa-addins-view';
import type { AddinCommandSurfaceItem, ExtensibilityModeEnum } from 'owa-addins-types';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';
import { trace } from 'owa-trace';

export default function getAddinCollection(
    mode: ExtensibilityModeEnum,
    isSharedItem: boolean,
    hostItemIndex: string,
    mailboxInfo: MailboxInfo,
    targetWindow: Window
): AddinCommandSurfaceItem[] {
    const addins: AddinCommandSurfaceItem[] = [];
    /* eslint-disable-next-line no-restricted-properties -- (https://aka.ms/OWALintWiki)
     * BASELINE. Do not copy and paste!
     *	> 'tryImportForRender' is restricted from being used. tryImportForRender should only be used in rare circumstances and can hurt TTI if used incorrectly. */
    const addinObserver = lazyAddinCommandSurfaceItemsObserver.tryImportForRender();
    if (addinObserver) {
        const addinSurfaceItems = addinObserver(
            mode,
            isSharedItem,
            hostItemIndex,
            mailboxInfo,
            targetWindow
        ).get();

        if (addinSurfaceItems?.sectionProps) {
            addins.push(
                ...addinSurfaceItems.sectionProps.items.filter(
                    addin => !(addin.name == 'FindTime' && isFeatureEnabled('cal-native-findtime'))
                )
            );
        }
    } else {
        trace.warn('Addin collection getter not available in Mail', 'addins');
    }

    return addins;
}
